import React from "react";
import Box from "../Box.js";

export default class TrudatMonth extends React.Component {
  render() {
    return (
      <div className="hp__block hp__block__month container text-center">
        <div className="row">
          <div className="col-md-6">
            <div className="hp__block__month-wrapper">
              <h3> Trudat Miesiąca </h3>
              <Box
                {...this.props}
                type="tetragon"
                id="b1"
                settings={this.props.settings.b1}
                classes="hp__box__background-tetragon-big hp__block__month-truth-negative-margin"
              />
              {/*<div className="hp__block__month-truth">
                            <h4> PRAWDA </h4> 
                            <p> Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum. </p>
                            <div> <a href=""> Czytaj więcej </a> </div>
                        </div> <=== this may be used later if client asks for it, css is still alive so just uncomment this and you're good */}
            </div>
          </div>
          <div className="col-md-6">
            <Box
              {...this.props}
              type="trudat-popular"
              id="b2"
              settings={this.props.settings.top_posts}
            />
          </div>
        </div>
      </div>
    );
  }
}
